import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@/shared/ui/buttons/Button';
import { showToast } from '@/shared/hooks/useToast';

type AppleLoginButtonProps = {
  isLoading: boolean;
  onRequestNative: () => boolean;
};

const AppleIcon = () => (
  <svg
    viewBox="0 0 24 24"
    className="h-5 w-5"
    fill="currentColor"
    aria-hidden
    focusable="false"
  >
    <path d="M16.365 1.43c0 1.14-.44 2.24-1.23 3.06-.83.86-2.17 1.52-3.32 1.43-.14-1.11.42-2.28 1.16-3.05.83-.87 2.26-1.5 3.39-1.44zM20.5 17.02c-.55 1.27-.81 1.83-1.52 2.95-.99 1.56-2.38 3.5-4.11 3.51-1.53.02-1.93-.99-4.01-.98-2.08.01-2.52 1-4.06.98-1.72-.02-3.04-1.77-4.03-3.33-2.77-4.37-3.06-9.5-1.35-12.22 1.21-1.94 3.13-3.08 4.93-3.08 1.84 0 2.99 1 4.51 1 1.47 0 2.37-1 4.5-1 1.61 0 3.32.88 4.53 2.39-3.98 2.18-3.34 7.87.61 9.41z" />
  </svg>
);

export const FeaturesAuthAppleLoginButton = ({
  isLoading,
  onRequestNative,
}: AppleLoginButtonProps) => {
  const { t } = useTranslation('login');
  const handleClick = useCallback((): void => {
    const ok = onRequestNative();
    if (!ok) {
      showToast({ kind: 'error', message: t('bridgeNoResponse') });
    }
  }, [onRequestNative, t]);

  return (
    <Button
      type="button"
      size="lg"
      block
      onClick={handleClick}
      loading={isLoading}
      leftIcon={<AppleIcon />}
      className="bg-black text-white hover:bg-neutral-900 active:bg-black disabled:bg-neutral-700"
    >
      {t('apple')}
    </Button>
  );
};
